<template lang="pug">
div.main
  v-row(no-gutters)
    v-col.pa-8(cols="3")
      patient-profile-details
    v-divider(vertical)
    v-col.pa-8(cols="9")
      patient-profile-tabs
</template>

<script>
import { mapGetters } from 'vuex'
import PatientProfileDetails from '@/components/clinic/patient/PatientProfileDetails.vue'
import PatientProfileTabs from '@/components/clinic/patient/PatientProfileTabs.vue'

export default {
  components: {
    PatientProfileDetails, PatientProfileTabs
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
  },
  mounted () {
    this.fetchCustomFields()
  },
  methods: {
    fetchCustomFields() {
      let params = { page_size: -1 }
      this.$axios.get(`/clinics/${this.company.slug}/patient_custom_fields`, { params })
      .then(resp => {
        const results = resp.data?.results
        if (results) {
          const fields = []
          results.forEach(field => {
            if (field.status === 'active') {
              field.enable = false
              fields.push(field)
            }
          })
          this.$store.commit('clinic/setCustomFields', fields)
        }
      })
      .catch(() => {})
    },
  }
}
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 100% !important;
  height: 100% !important;
}
</style>